var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h3', {
    attrs: {
      "data-tracking-codes": _vm.trackingCodes.join('|')
    }
  }, [_vm._v("Scan labels")]), _c('p', [_vm._v(" " + _vm._s(_vm.scannedLabelsQuantity) + " van " + _vm._s(_vm.labelsTotalQuantity) + " gescand ")]), _c('b-alert', {
    attrs: {
      "show": _vm.hasError,
      "fade": "",
      "variant": "danger"
    }
  }, [_vm._v(" Fout bij het controleren van het verzendlabel. Probeer het opnieuw, of: "), _c('b-button', {
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('fail');
      }
    }
  }, [_vm._v("ga toch door")]), _vm._v(". ")], 1), _c('b-alert', {
    attrs: {
      "show": _vm.isTrackingCodeNotFound,
      "fade": "",
      "variant": "warning"
    }
  }, [_vm._v(" Barcode niet gevonden"), _vm.labelsTotalQuantity > 1 ? _c('span', [_vm._v(" of is al gescand")]) : _vm._e(), _vm._v(". ")]), _c('b-form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.submit.apply(null, arguments);
      }
    }
  }, [_c('b-input', {
    key: _vm.scanCounter /*For re-triggering the autofocus*/,
    ref: "valueInput",
    staticClass: "d-inline-block mr-2",
    staticStyle: {
      "width": "230px"
    },
    attrs: {
      "type": "text",
      "placeholder": "Barcode",
      "required": "",
      "autofocus": "",
      "autocomplete": "off",
      "disabled": _vm.isProcessing
    },
    model: {
      value: _vm.scanValue,
      callback: function ($$v) {
        _vm.scanValue = typeof $$v === 'string' ? $$v.trim() : $$v;
      },
      expression: "scanValue"
    }
  }), _c('b-button', {
    attrs: {
      "variant": "primary",
      "type": "submit",
      "disabled": _vm.isProcessing
    }
  }, [!_vm.isProcessing ? _c('span', [_vm._v("Scan")]) : _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }